import { render, staticRenderFns } from "./DebtorOverviewTable.vue?vue&type=template&id=0791128e&"
import script from "./DebtorOverviewTable.vue?vue&type=script&lang=js&"
export * from "./DebtorOverviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports